module.exports = __webpack_public_path__ + "media/Text_center_med.906592c2.mp4";